<template>
  <div class="list-item">
    <div class="list-item__info">
      <div class="list-item__desc">{{ item.description }}</div>
      <div class="list-item__metadata">
        {{ item.date }}
        <span v-if="item.category">| {{ item.category }}</span>
      </div>
    </div>
    <div class="list-item__amount">
      <span v-if="item.type === 'expense'">-{{ item.amount | formatAmount}}</span>
      <span v-else>{{ item.amount | formatAmount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemListElement',

  props: ['item'],

  filters: {
    formatAmount(value) {
      if (!value) {
        return '?.??'
      }
      return Number.parseFloat(value).toFixed(2)
    }
  }
}
</script>

<style>
.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 400px;
}

.list-item__metadata {
  color: #808080;
  font-size: 13px;
  line-height: 1.5;
}

.list-item__info {
  flex-grow: 3;
}

.list-item__amount {
  flex-grow: 1;
  text-align: right;
}
</style>
